import templateUrl from './publishingAtAGlanceOpenCalendar.html';
import './publishingAtAGlanceOpenCalendar.scss';

import {createLogger} from '../../../common/logging.config';
const logger = createLogger('publishing-at-a-glance-open-calendar');

class PublishingAtAGlanceOpenCalendarController {
	constructor($state, homepageUtil) {
		this.$state = $state;
		this.homepageUtil = homepageUtil;
		// icon used for open calendar button
		this.img = require('../../../common/icons/Clock-20px-Glance.svg');

		// this should be called when page loading completes
		angular.element(() => {
			this.adjustRendering();
		});

		$(window).resize(this.adjustRendering);
	}
	
	navigateToPublishCalendar(event) {
		// on keypress event, only accept enter or space
		const keycode = this.homepageUtil.getKeyCode(event);
		if (typeof keycode !== 'undefined' && keycode !== 13 && keycode !== 32) {
			return;
		}
		this.$state.go('prod-authoring-publishing-ui.root');
	}

	// maintain the top padding as the title bar height changes when things get resized
	adjustRendering() {
		const titlebarHeight = angular.element(document.querySelector('#pub_glance>.widget>.titlebar')).outerHeight();
		let newPadding = 60;
		if (titlebarHeight > 90) {
			newPadding = 26;
		}
		else if (titlebarHeight > 70) {
			newPadding = 44;
		}
		const newPaddingTop = 'padding-top:' + newPadding + 'px';
		const openCals = document.querySelectorAll('publishing-at-a-glance-open-calendar>.calendar-icon');
		// no forEach support, sigh
		for(let index = 0; index < openCals.length; index++) {
			angular.element(openCals[index]).attr('style', newPaddingTop);
		}
		
	}
}

export default {
	controller: [ '$state', 'homepageUtil', PublishingAtAGlanceOpenCalendarController ],
	templateUrl
};



// WEBPACK FOOTER //
// ./app/components/publishingAtAGlance/publishingAtAGlanceOpenCalendar/publishingAtAGlanceOpenCalendar.component.js